import { useOfficeSiteContext } from '@context/OfficeSiteContext'
import { useSiteSettingsContext } from '@context/SiteSettingsContext'
import Button from '@global/Button'
import { Link } from '@routes'

const AppraisalButton = ({ onClick }) => {
  const { settings } = useSiteSettingsContext()
  const officeContext = useOfficeSiteContext()
  const cta = settings?.contentsettings?.appraisal_call_to_action?.[0]
  const appraisalUrl = cta?.call_to_action_link?.path || ''

  return (
    <div className='bp-appraisal-button'>
      {appraisalUrl && (
        <Link
          route={
            officeContext?.currentSite?.officeId
              ? `${appraisalUrl}${officeContext?.currentSite?.officePath.replace(
                  '/offices/',
                  ''
                )}`
              : appraisalUrl
          }
          passHref
          onClick={onClick}
        >
          <Button color='primary' className='btn-appraisal'>
            Get an Appraisal
          </Button>
        </Link>
      )}
    </div>
  )
}

export default AppraisalButton
